<!--
 * @Author: your name
 * @Date: 2022-01-11 18:03:20
 * @LastEditTime: 2022-01-14 16:48:58
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/changma202201/components/video.vue
-->
<!--
    视频模块
-->
<template>
    <div class="video">
        <div id="video">
            <video ref="video" data-v-3b1260f5="" id="vido_one" :src="src"
            controls="controls"
            webkit-playsinline="" :poster="poster"
            playsinline="" x5-video-player-type="h5" class="video__player poster">
                抱歉，您的浏览器不支持内嵌视频
            </video>
        </div>  
    </div>
</template>
<script>
    export default {
        props:['src','poster'],
        methods:{
            pause(){
                // document.getElementById("myaudio").pause();
                this.$refs.video.pause();
            }
        }
    }
</script>
<style lang="less" scoped>
    .video{
        &-tit{
            width:calc(100% - 94px);
            padding-top:40px;
            margin-left:auto;
            margin-right:auto;
            margin-bottom:18px;
        }
        video{
            width:100%;
            height:170px;
            margin-left:auto;
            margin-right:auto;
        }
    }
</style>